import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const messages = {  
                    'en': 
                    {
                        sessionEmail: 'Email address',
                        sessionEmailPlaceholder:'Enter email',
                        sessionPassword:'Password',
                        sessionPasswordPlaceholder:'Enter password',
                        sessionForgotPassword:'Forgot password?',
                        sessionSignInButton: 'Sign in',
                        dashboardUser: 'Log',
                        dashboardAddUser: 'Add User',
                        dashboardAddShift:'Add Shift',
                        tableUsersCol1:'Reader',
                        tableUsersCol2:'Name',
                        tableUsersCol3:'Surname',
                        tableUsersCol4:'Email',
                        tableUsersCol5:'Start',
                        tableUsersCol6:'Finish',
                        tableUsersCol7:'Work Time',
                        tableUsersCol8:'Shift',
                        tableUsersBack:'Back',
                        tableUsersNext:'Next',
                        keyEmail:'Email',
                        keyNotRegisteredEmail:'This email does not exist within the database, therefore we will create a user with a random password.',
                        keyRegisteredEmail:'This email has been found',
                        keyInitDate:'Commencement date',
                        keyFinishDate:'Completion date',
                        shiftInitTime:'Commencement hour',
                        shiftFinishTime:'Completion hour',
                        userSelectShift:'Shifts',
                        keySelectLock:'Reader',
                        keySelection:'Choose...',
                        addShift:'Add Shift',
                        daysOfShift:'Select the days of the shift',
                        lockNameUpdate:'Select a reader to update',
                        lockNewNameUpdate: 'Name of reader',
                        lockNewDescriptionUpdate: 'Description of reader',
                        lockUpdateButton:'Update',
                        ResetPassEmail: 'Email address',
                        ResetPassOld: 'Old password',
                        ResetPassNew: 'New password',
                        ResetPassNewConfirm: 'Confirm new password',
                        ResetPassName:'Name',
                        ResetPassSurname:'Surname',
                        ResetPassPhone:'Phone',
                        PlaceholderResetPassEmail: 'Type your email address',
                        PlaceholderResetPassOld: 'Type your password to verify and could update your account',
                        PlaceholderResetPassNew: 'Type your new password',
                        PlaceholderResetPassNewConfirm: 'Confirm your new password',
                        dashboardEditUser: 'Owner Account',
                        userUpdateButton: 'Update',
                        userUpdateCorrectLogin: 'The login credentials correspond to the account',
                        userUpdateUncorrectLogin:'The login credentials not correspond to the account',
                        userUpdateCorrectConfirmPass: 'New password and the confirm password are the same',
                        userUpdateUncorrectConfirmPass:'New password and the confirm password are not the same',
                        passwordForgotEmail: 'An email will be sent to the address provided to reset the password',
                        passwordForgotEmail2: 'This email must be the same as the one used to log in',
                        passwordForgotSendButton: 'Send email',
                        passwordForgotNotEmptyEmail:'Type an email',
                        addKeyLanguage: 'All languages',
                        addKeyLanguages: 'Select the language of the user',
                        errorSelectLocker:'Select a reader',
                        errorUpdateLocker:'Introduce new reader name or a new reader description',
                        lockerUpdate:'Reader Updated',
                        lockerNotUpdate:'Reader not Updated',
                        ownerUpdate:'Owner Updated',
                        ownerNotUpdate:'Owner not Updated',
                        logoutTextCancelOption:'Cancel',
                        deletingKeyTitle:'Are you sure?',
                        deletingKeyText:'You are deleting a key',
                        deletingKeyConfirmButton:'Delete',
                        deletingKeyOk:'Key deleted successfully',
                        correctLogin:'Correct Login',
                        uncorrectLogin: 'Uncorrect Login',
                        logoutTextOption:'Yes',
                        logoutTextTitle:'Do you want to logout?',                 
                        shiftDay1:'Monday',
                        shiftDay2:'Tuesday',
                        shiftDay3:'Wednesday',
                        shiftDay4:'Thursday',
                        shiftDay5:'Friday',
                        shiftDay6:'Saturday',
                        shiftDay7:'Sunday',
                        addShiftComplete:'Shift has been added',
                        addUserWithShift:'Added the user with his or her shift',
                        userNotAdded:'The user has not been added',
                        isSplitShift:'Split Shift',
                        /*Añadir al resto de idiomas desde aqui*/
                        noShiftsToLock:'There are no shifts asign to this reader',
                        dashboardAddAccessUser:'Users',
                        tableUsersCol8:'Shift/s',
                        
                    },    
                    'es': 
                    {
                        sessionEmail: 'Dirección email',
                        sessionEmailPlaceholder:'Introduzca email',  
                        sessionPassword:'Contraseña',
                        sessionPasswordPlaceholder:'Introduzca la contraseña',
                        sessionForgotPassword:'¿Olvidaste la contraseña?',
                        sessionSignInButton:'Iniciar Sesión',
                        dashboardUser: 'Registro',
                        dashboardKey: 'Añadir llave',
                        dashboardEditLock:'Editar lector',
                        errorSelectLocker:'Seleccione un lector',
                        tableUsersCol2:'Nombre',
                        tableUsersCol3:'Apellidos',
                        tableUsersCol4:'Email',
                        tableUsersCol5:'Inicio',
                        tableUsersCol6:'Fin',
                        tableUsersBack:'Atrás',
                        tableUsersNext:'Siguiente',
                        keyEmail:'Email',
                        keyNotRegisteredEmail:'No existe este correo, dentro de la base de datos, por tanto se procederá a crear un usuario con una contraseña aleatoria.',
                        keyRegisteredEmail:'El correo ha sido encontrado.',
                        keyInitDate:'Fecha de inicio',
                        keyFinishDate:'Fecha de finalización',
                        keySelectLock:'Lector',
                        keySelection:'Elige...',
                        keyAdd:'Añadir',
                        lockNameUpdate:'Seleccione un lector para actualizar',
                        lockNewNameUpdate: 'Nombre del lector',
                        lockNewDescriptionUpdate: 'Descripción del lector',
                        lockUpdateButton:'Actualizar',
                        ResetPassEmail: 'Dirección de correo',
                        ResetPassOld: 'Contraseña antigua',
                        ResetPassNew: 'Contraseña nueva',
                        ResetPassNewConfirm: 'Confirmación de la nueva contraseña',
                        ResetPassName:'Nombre',
                        ResetPassSurname:'Apellidos',
                        ResetPassPhone:'Teléfono',
                        PlaceholderResetPassEmail: 'Introduce tu dirección de correo electrónico',
                        PlaceholderResetPassOld: 'Introduce tu contraseña para verificar y poder actualizar tu perfil',
                        PlaceholderResetPassNew: 'Introduce tu nueva contraseña',
                        PlaceholderResetPassNewConfirm: 'Confirma tu nueva contraseña',
                        dashboardEditUser: 'Perfil Owner',
                        userUpdateButton: 'Actualizar',
                        userUpdateCorrectLogin: 'Las credenciales corresponden a la cuenta',
                        userUpdateUncorrectLogin:'Las credenciales no corresponden a la cuenta',
                        userUpdateCorrectConfirmPass: 'La nueva contraseña y la confirmación son iguales',
                        userUpdateUncorrectConfirmPass:'La nueva contraseña y la confirmación no son iguales',
                        passwordForgotEmail: 'Se enviará un email a la dirección proporcionada para reestablecer la contraseña',
                        passwordForgotEmail2: 'Este email tiene que ser el mismo que se usa para iniciar sesión',
                        passwordForgotSendButton: 'Enviar email',
                        passwordForgotNotEmptyEmail:'Introduce un email',
                        addKeyLanguage: 'Todos los idiomas',
                        addKeyLanguages: 'Seleccione el idioma del usuario',
                        errorUpdateLocker:'Introduce un nombre nuevo o una descripcion nueva del lector',
                        lockerUpdate:'Lector Actualizado',
                        lockerNotUpdate:'Lector no Actualizado',
                        ownerUpdate:'Propietario Actualizado',
                        ownerNotUpdate:'Propietario no Actualizado',
                        logoutTextCancelOption:'Cancelar',
                        deletingKeyTitle:'¿Estas segur@?',
                        deletingKeyText:'Estas intentando borrar una llave',
                        deletingKeyConfirmButton:'Borrar',
                        deletingKeyOk:'Llave eliminada satisfactoriamente',
                        correctLogin:'Login Correcto',
                        uncorrectLogin: 'Login Incorrecto',
                        logoutTextOption:'Si',
                        logoutTextTitle:'¿Quieres cerrar sesión?',
                        tableUsersCol7:'Tiempo de trabajo',
                        dashboardAddUser: 'Añadir Usuario',
                        dashboardAddShift:'Añadir Turno',
                        tableUsersCol1:'Lector',
                        userSelectShift:'Horarios',
                        daysOfShift:'Selecciona los días del turno',
                        shiftInitTime:'Hora de comienzo',
                        shiftFinishTime:'Hora de finalización',
                        shiftDay1:'Lunes',
                        shiftDay2:'Martes',
                        shiftDay3:'Miércoles',
                        shiftDay4:'Jueves',
                        shiftDay5:'Viernes',
                        shiftDay6:'Sábado',
                        shiftDay7:'Domingo',
                        addShiftComplete:'Se ha añadido el turno',
                        addUserWithShift:'Se ha añadido el usuario con su turno',
                        userNotAdded:'No se ha insertado el usuario',
                        isSplitShift:'Turno partido',
                        /*Añadir al resto de idiomas desde aqui*/
                        noShiftsToLock:'No hay turnos asignados a este lector',
                        dashboardAddAccessUser:'Usuario/s',
                        tableUsersCol8:'Turno/s',
                    },
                    'de':
                    {
                        sessionEmail: 'E-Mail-Adresse',
                        sessionEmailPlaceholder:'E-Mail eingeben',  
                        sessionPassword:'Passwort',
                        sessionPasswordPlaceholder:'Geben Sie das Passwort ein',
                        sessionForgotPassword:'Passwort vergessen?',
                        sessionSignInButton:'Login',
                        dashboardUser: 'Anmeldung',
                        dashboardKey: 'Schlüssel hinzufügen',
                        dashboardEditLock:'Sperre bearbeiten',
                        tableUsersCol1:'Schloss',
                        tableUsersCol2:'Name',
                        tableUsersCol3:'Nachname',
                        tableUsersCol4:'E-Mail',
                        tableUsersCol5:'Start',
                        tableUsersCol6:'Ende',
                        tableUsersBack:'Zurück',
                        tableUsersNext:'Weiter',
                        keyEmail:'E-Mail',
                        keyNotRegisteredEmail:'Diese E-Mail existiert nicht in der Datenbank, daher werden wir fortfahren, einen Benutzer mit einem zufälligen Passwort zu erstellen',
                        keyRegisteredEmail:'Die E-Mail wurde gefunden',
                        keyInitDate:'Startdatum',
                        keyFinishDate:'Enddatum',
                        keySelectLock:'Schloss',
                        keySelection:'Wählen Sie...',
                        keyAdd:'Hinzufügen',
                        lockNameUpdate:'Wählen Sie eine Sperre zum Aktualisieren',
                        lockNewNameUpdate: 'Name sperren',
                        lockNewDescriptionUpdate: 'Beschreibung des Schlosses',
                        lockUpdateButton:'Aktualisieren',
                        ResetPassEmail: 'E-Mail-Adresse',
                        ResetPassOld: 'Altes Passwort',
                        ResetPassNew: 'Neues Passwort',
                        ResetPassNewConfirm: 'Bestätigung des neuen Passworts',
                        ResetPassName:'Name',
                        ResetPassSurname:'Nachname',
                        ResetPassPhone:'Telefon',
                        PlaceholderResetPassEmail: 'Geben Sie Ihre E-Mail-Adresse ein',
                        PlaceholderResetPassOld: 'Gib dein Passwort ein, um dein Profil zu überprüfen und zu aktualisieren',
                        PlaceholderResetPassNew: 'Geben Sie Ihr neues Passwort ein',
                        PlaceholderResetPassNewConfirm: 'Bestätigen Sie Ihr neues Passwort',
                        dashboardEditUser: 'Besitzerprofil',
                        userUpdateButton: 'Aktualisieren',
                        userUpdateCorrectLogin: 'Die Zugangsdaten entsprechen dem Konto',
                        userUpdateUncorrectLogin:'Die Zugangsdaten entsprechen nicht dem Konto',
                        userUpdateCorrectConfirmPass: 'Neues Passwort und Bestätigung sind gleich',
                        userUpdateUncorrectConfirmPass:'Neues Passwort und Bestätigung sind nicht identisch',
                        passwordForgotEmail: 'Eine E-Mail wird an die angegebene Adresse gesendet, um das Passwort zurückzusetzen',
                        passwordForgotEmail2: 'Diese E-Mail muss mit derjenigen übereinstimmen, mit der du dich angemeldet hast',
                        passwordForgotSendButton: 'E-Mail senden',
                        passwordForgotNotEmptyEmail:'Geben Sie eine E-Mail ein',
                        addKeyLanguage: 'Alle Sprachen',
                        addKeyLanguages: 'Wählen Sie die Sprache des Benutzers aus',
                        errorSelectLocker:'Wählen Sie eine Sperre',
                        errorUpdateLocker:'Geben Sie einen neuen Namen oder eine neue Beschreibung der Sperre ein',
                        lockerUpdate:'Aktualisierte Sperre',
                        lockerNotUpdate:'Sperre nicht aktualisiert',
                        ownerUpdate:'Besitzer aktualisiert',
                        ownerNotUpdate:'Besitzer nicht aktualisiert',
                        logoutTextCancelOption:'Abbrechen',
                        deletingKeyTitle:'Bist du sicher?',
                        deletingKeyText:'Du versuchst, einen Schlüssel zu löschen',
                        deletingKeyConfirmButton:'Löschen',
                        deletingKeyOk:'Schlüssel erfolgreich entfernt',
                        correctLogin:'Korrektes Login',
                        uncorrectLogin: 'Falsches Login',
                        logoutTextOption:'Ja',
                        logoutTextTitle:'Möchten Sie sich abmelden?',            
                        tableUsersCol7:'Arbeitszeit',
                        dashboardAddUser: 'Benutzer hinzufügen',
                        dashboardAddShift:'Schicht hinzufügen',
                        tableUsersCol1:'Lesegerät',
                        userSelectShift:'Zeiten',
                        daysOfShift:'Wählen Sie die Tage der Schicht aus',
                        shiftInitTime:'Startzeit',
                        shiftFinishTime:'Endzeit',
                        shiftDay1:'Montag',
                        shiftDay2:'Dienstag',
                        shiftDay3:'Mittwoch',
                        shiftDay4:'Donnerstag',
                        shiftDay5:'Freitag',
                        shiftDay6:'Samstag',
                        shiftDay7:'Sonntag',
                        addShiftComplete:'Schicht wurde hinzugefügt',
                        addUserWithShift:'Der Benutzer wurde mit seinem Zug hinzugefügt',
                        userNotAdded:'Der Benutzer wurde nicht eingefügt',
                        isSplitShift:'Schichtabgleich',
                        /*Añadir al resto de idiomas desde aqui*/
                        noShiftsToLock:'Diesem Leser sind keine Schichten zugeordnet',
                        dashboardAddAccessUser:'Benutzer',
                        tableUsersCol8:'Verschiebung/en',
                    }
                };
export default new VueI18n({    
                            locale: 'en', // set locale 
                            fallbackLocale: 'es', // set fallback locale    
                            messages, // set locale messages
                        });



// WEBPACK FOOTER //
// ./src/plugins/i18n.js